import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const names = ['Sofía', 'Lucas', 'Martín', 'Camila', 'Diego', 'Valentina', 'Mateo', 'Julieta', 'Tomás', 'Florencia', 'Agustín', 'Catalina', 'Joaquín', 'Micaela', 'Bruno'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bariloche', 'Resistencia', 'Posadas', 'Corrientes'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 1
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 3000);
    // Then repeat every 30 seconds
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-278">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-gray-100 p-4 pr-10 max-w-sm flex items-start gap-4" data-id="element-279">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-280">
            <X className="w-4 h-4" data-id="element-281" />
          </button>

          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-282">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-283" />
          </div>

          <div data-id="element-284">
            <p className="text-sm text-gray-800 leading-tight mb-1" data-id="element-285">
              <span className="font-bold" data-id="element-286">{data.name}</span> de{' '}
              <span className="font-bold" data-id="element-287">{data.city}</span> acaba de comprar
              NATACIÓN 360
            </p>
            <p className="text-xs text-gray-500" data-id="element-288">
              hace {data.time} {data.time === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}